import { inject } from 'mobx-react';
import * as React from 'react';
import debounce from 'lodash.debounce';

import { PropertySearchLink } from '@shared-ui/lodging-property-offers';

import { SharedUiWrapperProps, withSharedUiPropertyOffers } from './shared-ui-property-offers';

const PropertySearchLinkWrapper: React.FC<SharedUiWrapperProps> = inject('currentHotel')(({ currentHotel, inputs }) => {
  const resetIsNavigationFromSRP = debounce(() => {
    currentHotel?.setIsNavigationFromSRP(false);
  });

  React.useEffect(() => () => {
    resetIsNavigationFromSRP();
  });

  return <PropertySearchLink inputs={inputs} skipSsr={true} isNavigationFromSRP={currentHotel?.isNavigationFromSRP} />;
});

PropertySearchLinkWrapper.displayName = 'SharedUiPropertySearchLinkWrapper';
export const SharedUiPropertySearchLinkWrapper = withSharedUiPropertyOffers(PropertySearchLinkWrapper);
